import http from "./http";

// export const baseUrl = process.env.VUE_APP_URL;
export const baseUrl = process.env.VUE_APP_URL;

export const SUCCESS_CODE = 20000;
export const CMD_SUCCESS_CODE = 20005;
export const LOGIN_SUCCESS = 20001;
export const FAILED_CODE = 50000;

//解析token
export const checkToken = () => {
	return http.requestGet(baseUrl + "/uc/admin/token");
};
//登录
export const doLogin = (verifyCode, lci, user) => {
	return http.requestPost(baseUrl + "/uc/admin/login?captcha=" + verifyCode + "&l-c-i=" + lci, user);
};
//创建睡前故事分类
export const postSleepCategory = (category) => {
	return http.requestPost(baseUrl + "/prs/category", category);
};
export const putSleepCategory = (category) => {
	return http.requestPut(baseUrl + "/prs/category/" + category.id, category);
};
//获取睡前故事分类列表
export const listStoryCategories = () => {
	return http.requestGet(baseUrl + "/prs/categories");
};
//删除睡前故事分类
export const deleteStoryCategory = (id) => {
	return http.requestDelete(baseUrl + "/prs/category/" + id);
};
//创建故事
export const postStory = (story) => {
	return http.requestPost(baseUrl + "/prs/story", story);
};
//更新故事
export const putStory = (story) => {
	return http.requestPut(baseUrl + "/prs/story/" + story.id, story);
};
//创建mp3的令牌
export const getMp3PlayToken = (id) => {
	return http.requestGet(baseUrl + "/md/mp3/token/" + id);
};
//删除故事
export const deleteStory = (id) => {
	return http.requestDelete(baseUrl + "/prs/story/" + id);
};
//获取故事列表
export const listStories = (page, search) => {
	return http.requestGet(
		baseUrl + "/prs/story/list/" + page + "?categoryId=" + search.categoryId + "&name=" + search.name
	);
};
//退出登录
export const logout = () => {
	return http.requestGet(baseUrl + "/uc/admin/logout");
};
//创建教材
export const postBook = (book) => {
	return http.requestPost(baseUrl + "/wd/book", book);
};
//更新教材
export const putBook = (book) => {
	return http.requestPut(baseUrl + "/wd/book/" + book.id, book);
};
//删除教材
export const deleteBook = (bookId) => {
	return http.requestDelete(baseUrl + "/wd/book/" + bookId);
};
//获取教材列表
export const listBook = (page, name) => {
	return http.requestGet(baseUrl + "/wd/book/list/" + page + "?name=" + name);
};
//获取书本详情
export const getBookDetail = (bookId) => {
	return http.requestGet(baseUrl + "/wd/book/" + bookId);
};
//创建识字分组
export const postWordGroup = (workGroup) => {
	return http.requestPost(baseUrl + "/wd/word-group", workGroup);
};
//更新识字分组
export const updateWordGroup = (workGroup) => {
	return http.requestPut(baseUrl + "/wd/word-group/" + workGroup.id, workGroup);
};
//获取分组列表
export const listWordGroup = (bookId) => {
	return http.requestGet(baseUrl + "/wd/word-group/list/" + bookId);
};
//获取分组列表
export const listWordGroupSimple = (bookId) => {
	return http.requestGet(baseUrl + "/wd/word-group/list/simple/" + bookId);
};
//上传MP4文件
export const postMp4 = (mp4) => {
	return http.requestPost(baseUrl + "/md/mp4", mp4);
};
export const postPubMp4 = (mp4) => {
	return http.requestPost(baseUrl + "/md/mp4/pub", mp4);
};
//上传MP4文件封面
export const postMp4Cover = (mp4Cover) => {
	return http.requestPost(baseUrl + "/md/image/video-cover", mp4Cover);
};
//上传MP3文件
export const postMp3 = (mp3) => {
	return http.requestPost(baseUrl + "/md/mp3", mp3);
};
export const postPubMp3 = (mp3) => {
	return http.requestPost(baseUrl + "/md/mp3/pub", mp3);
};
export const postPubMp3ToUrl = (mp3) => {
	return http.requestPost(baseUrl + "/md/mp3/pub/url", mp3);
};
//上传游戏图片
export const postGameImage = (image) => {
	return http.requestPost(baseUrl + "/md/image/game", image);
};
//上传文字图片
export const postWordImage = (image) => {
	return http.requestPost(baseUrl + "/md/image/word-image", image);
};
//上传文字内容
export const postWordItem = (wordItem) => {
	return http.requestPost(baseUrl + "/wd/word", wordItem);
};
//删除组
export const deleteWordGroup = (groupId) => {
	return http.requestDelete(baseUrl + "/wd/word-group/" + groupId);
};
//获取视频令牌
export const getVideoToken = (videoId) => {
	return http.requestGet(baseUrl + "/md/mp4/token/" + videoId);
};
//更新识字内容
export const updateWordItem = (wordItem) => {
	return http.requestPut(baseUrl + "/wd/word/" + wordItem.id, wordItem);
};
//删除识字内容
export const deleteWordItem = (wordId) => {
	return http.requestDelete(baseUrl + "/wd/word/" + wordId);
};
//获取识字列表
export const listWord = (page, search) => {
	return http.requestGet(
		baseUrl + "/wd/word/list/" + page + "?word=" + search.word + "&bookId=" + search.bookId + "&enable=" + search.enable
	);
};
//获取书本列表
export const listBookSimple = () => {
	return http.requestGet(baseUrl + "/wd/book/list/simple");
};
//上传分组的封面
export const postWordGroupCover = (image) => {
	return http.requestPost(baseUrl + "/md/image/word-group", image);
};
//上传分组的封面
export const postReadingCover = (image) => {
	return http.requestPost(baseUrl + "/md/image/reading-cover", image);
};
//上传读本
export const postReading = (reading) => {
	return http.requestPost(baseUrl + "/wd/reading", reading);
};
//更新读本
export const putReading = (reading) => {
	return http.requestPut(baseUrl + "/wd/reading/" + reading.id, reading);
};
//获取读本列表
export const listReading = (page, search) => {
	return http.requestGet(baseUrl + "/wd/reading/list/" + page + "?enable=" + search.enable + "&name=" + search.name);
};
//删除读本
export const deleteReading = (id) => {
	return http.requestDelete(baseUrl + `/wd/reading/${id}`);
};
//获取读本详情
export const getReading = (readingId) => {
	return http.requestGet(baseUrl + "/wd/reading/" + readingId);
};
//获取读本内容列表
export const getReadingItem = (readingId) => {
	return http.requestGet(baseUrl + "/wd/reading-item/" + readingId);
};
//获取读本内容列表
export const getReadingItemDetail = (readingItemId) => {
	return http.requestGet(baseUrl + "/wd/reading-item/detail/" + readingItemId);
};
//上传读本的内容
export const postReadingItem = (readingItem) => {
	return http.requestPost(baseUrl + "/wd/reading-item", readingItem);
};
//上传读本的内容
export const updateReadingItem = (readingItem) => {
	return http.requestPut(baseUrl + "/wd/reading-item/" + readingItem.id, readingItem);
};
//删除读本内容
export const deleteReadingItem = (readingItemId) => {
	return http.requestDelete(baseUrl + "/wd/reading-item/" + readingItemId);
};
//获取读本列表
export const likeReading = (moduleId, query) => {
	return http.requestGet(baseUrl + `/wd/reading/like/?moduleId=${moduleId}&name=${query}`);
};
//关联读本
export const postWordGroupReading = (groupId, readingItemId) => {
	return http.requestPost(baseUrl + `/wd/word-group-reading/${groupId}/${readingItemId}`);
};
//上传读本游戏图片
export const postReadingTestImage = (image) => {
	return http.requestPost(baseUrl + "/md/image/reading-test", image);
};
//更新读本游戏
export const postReadingTest = (readingTest) => {
	return http.requestPost(baseUrl + "/wd/reading-test", readingTest);
};
//上传读本游戏
export const updateReadingTest = (readingTest) => {
	return http.requestPut(baseUrl + "/wd/reading-test/" + readingTest.id, readingTest);
};
//获取读本测试
export const listReadingTest = (readingId, readingItemId) => {
	return http.requestGet(baseUrl + `/wd/reading-test/${readingId}/${readingItemId}`);
};
//删除读本测试
export const deleteReadingTest = (readingTestId) => {
	return http.requestDelete(baseUrl + "/wd/reading-test/" + readingTestId);
};
//删除组里的读本
export const deleteGroupReading = (groupId, readingId) => {
	return http.requestDelete(baseUrl + "/wd/word-group-reading/" + groupId + "/" + readingId);
};
//更新游戏
export const updateGame = (game) => {
	return http.requestPut(baseUrl + "/wd/game/" + game.id, game);
};
//创建游戏
export const postGame = (game) => {
	return http.requestPost(baseUrl + "/wd/game/", game);
};
//获取游戏列表
export const listGame = (page, search) => {
	return http.requestGet(baseUrl + "/wd/game/list/" + page + "?name=" + search.name + "&label=" + search.label);
};
//删除游戏
export const deleteGame = (id) => {
	return http.requestDelete(baseUrl + "/wd/game/" + id);
};
//更新游戏配置
export const updateGameConfig = (config) => {
	return http.requestPut(baseUrl + "/wd/game/config/" + config.id, config);
};
//上传游戏配置
export const postGameConfig = (config) => {
	return http.requestPost(baseUrl + "/wd/game/config", config);
};
//获取游戏配置
export const listGameConfig = (gameId) => {
	return http.requestGet(baseUrl + "/wd/game/config/" + gameId);
};
//删除配置
export const deleteGameConfig = (gameConfigId) => {
	return http.requestDelete(baseUrl + "/wd/game/config/" + gameConfigId);
};
//导入配置
export const postImportGameConfig = (importConfig) => {
	return http.requestPost(baseUrl + "/wd/game/config/json", importConfig);
};
//获取游戏配置
export const getGameConfig = (gameId) => {
	return http.requestGet(baseUrl + "/wd/game/config/json/" + gameId);
};

// 获取APP升级记录
export const listAppUpgrade = () => {
	return http.requestGet(baseUrl + "/sys/app-upgrade/manager/list");
};

// 新增APP升级记录
export const addAppUpgrade = (data) => {
	return http.requestPost(baseUrl + "/sys/app-upgrade/manager/add", data);
};

// 获取反馈列表
export const listFeedback = (pageNo, pageSize) => {
	return http.requestGet(baseUrl + `/uc/feedback/page?pageNo=${pageNo}&pageSize=${pageSize}`);
};

// 获取套餐包列表
export const resourcePackagePage = (pageNo, pageSize, name) => {
	return http.requestGet(baseUrl + `/uc/admin/resourcePackage/page?pageNo=${pageNo}&pageSize=${pageSize}&name=${name}`);
};

// 删除套餐包信息
export const resourcePackageDelete = (id) => {
	return http.requestGet(baseUrl + `/uc/admin/resourcePackage/deleteById/${id}`);
};

// 新增套餐包信息
export const resourcePackageSave = (data) => {
	return http.requestPost(baseUrl + `/uc/admin/resourcePackage/save`, data);
};

// 修改套餐包信息
export const resourcePackageUpdate = (id, data) => {
	return http.requestPut(baseUrl + `/uc/admin/resourcePackage/updateById/${id}`, data);
};

// 获取套餐包详情
export const resourcePackageDetail = (id) => {
	return http.requestGet(baseUrl + `/uc/admin/resourcePackage/getById/${id}`);
};

// 获取资源列表
export const getResourceList = () => {
	return http.requestGet(baseUrl + `/uc/admin/resourcePackage/get-resource-package`);
};

// 修改管理员密码
export const updateAdminPassword = (userName, md5OldPassword, md5NewPassword) => {
	return http.requestPut(
		baseUrl + `/uc/admin/pwd/name?userName=${userName}&oldPassword=${md5OldPassword}&newPassword=${md5NewPassword}`
	);
};

// 获取模块树形结构
export const getAppModuleTree = () => {
	return http.requestGet(baseUrl + `/uc/admin/appModule/tree-data`);
};
export const deleteAppModule = (id) => {
	return http.requestDelete(baseUrl + `/uc/admin/appModule/deleteById/${id}`);
};
export const saveAppModule = (data) => {
	return http.requestPost(baseUrl + `/uc/admin/appModule/save`, data);
};
export const updateAppModuleById = (id, data) => {
	return http.requestPut(baseUrl + `/uc/admin/appModule/updateById/${id}`, data);
};
